module.exports = "https://www.gc-pro.gnp.com.mx/4cfd36189d5da4d7d3602dace2ae010a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/page_1_copy_2.svg
// module id = 1855
// module chunks = 0